// @ts-nocheck

import * as R from 'ramda';
import { reducerWrapper } from '../support/utils';

import {
  DEEPVIEW_CREATE,
  DEEPVIEW_DELETE,
  DEEPVIEW_GET,
  DEEPVIEW_LIST,
  DEEPVIEW_SAVE,
  PROMPT_CANCEL,
  PROMPT_DEEPVIEW_DELETE,
  PROMPT_DEEPVIEW_ENABLE,
  PROMPT_ENABLE_CANCEL,
} from '../actions/DeepviewActions';

export const INIT_STATE = {
  loading: false,
  error: null,
  data: null,
  needs_sanitization: false,
};

function Handler(state, action) {
  const { data = {} } = action;
  switch (action.type) {
    case DEEPVIEW_SAVE.response:
      return R.merge(state, { loading: false, data });
    case DEEPVIEW_CREATE.response:
    case DEEPVIEW_GET.response:
      return R.merge(state, {
        loading: false,
        deepview_theme: data.deepview,
      });
    case DEEPVIEW_DELETE.response:
      return R.merge(state, {
        loading: false,
        open: false,
        list: state.list ? state.list.filter((deepview) => deepview.name !== data.id) : [],
      });
    case DEEPVIEW_LIST.request:
      return R.merge(state, { loading: true });
    case DEEPVIEW_LIST.response:
      return R.merge(state, { loading: false, list: data.deepviews });
    case PROMPT_DEEPVIEW_DELETE:
    case PROMPT_CANCEL:
      return R.merge(state, {
        open: data.open,
        name_to_delete: data.name,
      });
    case PROMPT_DEEPVIEW_ENABLE:
    case PROMPT_ENABLE_CANCEL:
      return R.merge(state, {
        enable_open: data.enable_open,
        name_to_enable: data.enable_name,
      });
    default:
      return state;
  }
}

const Deepview = reducerWrapper(INIT_STATE, Handler, {
  request: [DEEPVIEW_SAVE, DEEPVIEW_CREATE, DEEPVIEW_GET, DEEPVIEW_DELETE, DEEPVIEW_LIST],
  error: [DEEPVIEW_SAVE, DEEPVIEW_CREATE, DEEPVIEW_GET, DEEPVIEW_DELETE, DEEPVIEW_LIST],
  resetOn: ['APP_CHANGE'],
});

export default Deepview;
